/* sm-home-parallax.js — SanaManuka home (Home agent). Port of Manukora parallax-images.js:
   every img.sm-parallax scales from 1.2 to 1.0 as it travels up through the viewport.
   Guarded so several sections can include this file. */
(function () {
  if (window.SmParallax) { window.SmParallax.refresh(); return; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var P = {
    images: [], data: new Map(), visible: new Set(), ticking: false, observer: null,
    init: function () {
      if (reduce || !window.requestAnimationFrame) return;
      this.collect();
      if (!this.bound) {
        this.bound = true;
        var self = this;
        window.addEventListener('scroll', function () { self.tick(); }, { passive: true });
        window.addEventListener('resize', function () { clearTimeout(self.rt); self.rt = setTimeout(function () { self.recalc(); self.tick(); }, 150); }, { passive: true });
        window.addEventListener('load', function () { self.recalc(); self.tick(); });
      }
      this.updateAll(true);
    },
    collect: function () {
      var self = this;
      var list = Array.prototype.slice.call(document.querySelectorAll('img.sm-parallax'));
      if (!this.observer && window.IntersectionObserver) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) self.visible.add(e.target); else self.visible.delete(e.target); });
        }, { rootMargin: '50px 0px', threshold: 0 });
      }
      list.forEach(function (img) {
        if (self.images.indexOf(img) === -1) { self.images.push(img); if (self.observer) self.observer.observe(img); }
        self.cache(img);
        if (img.complete === false) img.addEventListener('load', function () { self.cache(img); self.update(img, true); }, { once: true });
      });
    },
    cache: function (img) {
      var r = img.getBoundingClientRect(); var st = window.pageYOffset || document.documentElement.scrollTop;
      // use the clipping parent's box so scale doesn't feed back into the measurement
      var box = img.parentElement ? img.parentElement.getBoundingClientRect() : r;
      this.data.set(img, { top: box.top + st, height: box.height, last: null });
    },
    recalc: function () { var self = this; this.images.forEach(function (img) { self.cache(img); }); },
    tick: function () { var self = this; if (this.ticking) return; this.ticking = true; requestAnimationFrame(function () { self.updateAll(false); self.ticking = false; }); },
    updateAll: function (initial) {
      var self = this; var wh = window.innerHeight; var st = window.pageYOffset || document.documentElement.scrollTop;
      var set = (this.observer && !initial) ? Array.from(this.visible) : this.images;
      set.forEach(function (img) { self.update(img, initial, wh, st); });
    },
    update: function (img, initial, wh, st) {
      wh = wh || window.innerHeight; st = st || (window.pageYOffset || document.documentElement.scrollTop);
      var d = this.data.get(img); if (!d) return;
      var top = d.top - st, bottom = top + d.height;
      if (!initial && (top > wh + 100 || bottom < -100)) return;
      var p; if (top >= wh) p = 0; else if (bottom <= 0) p = 1; else p = (wh - top) / (wh + d.height);
      p = Math.max(0, Math.min(1, p));
      var s = Math.round((1.2 - 0.2 * p) * 1000) / 1000;
      if (d.last !== null && Math.abs(d.last - s) < 0.001) return;
      d.last = s; img.style.transform = 'scale(' + s + ')';
    },
    refresh: function () { this.collect(); this.recalc(); this.updateAll(true); }
  };
  window.SmParallax = P;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { P.init(); }); else P.init();
})();
